import { cn } from "@/lib/utils";
import type { SVGProps } from "react";

/**
 * PakWheels favicon-style mark (official asset from pakwheels.com search loader).
 * Brand colors are fixed so the mark matches the real product icon at any menu size.
 */
export function PakWheelsIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 50 50"
      className={cn("shrink-0", className)}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <g>
        <path
          fill="#FFFFFF"
          stroke="#A30D23"
          strokeMiterlimit={10}
          d="M25.003,0.632c-13.458,0-24.371,10.91-24.371,24.362
		c0,13.458,10.913,24.375,24.371,24.375c13.462,0,24.365-10.916,24.365-24.375C49.368,11.542,38.465,0.632,25.003,0.632z"
        />
        <path
          fill="#E7232D"
          d="M25.003,0.089c-13.758,0-24.914,11.153-24.914,24.905c0,13.758,11.156,24.917,24.914,24.917
		c13.762,0,24.908-11.159,24.908-24.917C49.911,11.242,38.765,0.089,25.003,0.089z M25.003,44.494c-10.77,0-19.5-8.728-19.5-19.5
		c0-10.763,8.731-19.491,19.5-19.491c10.767,0,19.498,8.728,19.498,19.491C44.501,35.767,35.77,44.494,25.003,44.494z"
        />
        <path
          fill="#E7232D"
          d="M25.003,6.451c-10.245,0-18.552,8.304-18.552,18.542c0,10.251,8.307,18.555,18.552,18.555
		c10.242,0,18.549-8.304,18.549-18.555C43.552,14.755,35.245,6.451,25.003,6.451z M30.907,23.028
		c-0.056-0.168-0.113-0.327-0.189-0.489c2.883-4.897,8.862-6.396,9.71-6.591c1.553,2.657,2.452,5.748,2.452,9.046
		c0,0.936-0.067,1.853-0.205,2.751C41.986,24.232,31.86,23.12,30.907,23.028z M25.746,19.368c0.577,0,1.03,0.458,1.03,1.027
		s-0.453,1.03-1.03,1.03c-0.569,0-1.027-0.461-1.027-1.03S25.177,19.368,25.746,19.368z M25.003,23.006
		c1.098,0,1.996,0.887,1.996,1.987c0,1.107-0.898,2-1.996,2c-1.101,0-2-0.893-2-2C23.003,23.893,23.902,23.006,25.003,23.006z
		 M21.27,21.814c0.538,0.168,0.844,0.74,0.676,1.284c-0.166,0.55-0.74,0.85-1.281,0.685c-0.541-0.168-0.847-0.746-0.676-1.293
		C20.151,21.952,20.729,21.646,21.27,21.814z M21.292,28.923c-0.477-0.318-0.599-0.957-0.284-1.422
		c0.318-0.477,0.959-0.597,1.431-0.278c0.474,0.315,0.596,0.951,0.278,1.428C22.395,29.115,21.756,29.243,21.292,28.923z
		 M26.363,29.412c-0.354-0.446-0.281-1.098,0.159-1.453c0.443-0.354,1.085-0.284,1.44,0.159c0.357,0.44,0.29,1.086-0.147,1.443
		C27.369,29.916,26.725,29.852,26.363,29.412z M29.764,24.844c-0.526,0.214-1.126-0.04-1.336-0.568
		c-0.212-0.529,0.042-1.125,0.571-1.336c0.522-0.211,1.122,0.042,1.336,0.572C30.546,24.037,30.289,24.633,29.764,24.844z
		 M39.623,14.709c-3.21-1.773-11.67,4.766-11.67,4.766l0.074,0.08c-0.044-0.018-0.083-0.043-0.129-0.067
		c-0.944-5.481,2.517-10.376,3.21-11.303C34.572,9.447,37.535,11.743,39.623,14.709z M29.574,7.708
		c-3.507,0.981-5.871,11.202-5.871,11.202l0.413-0.07c-0.345,0.046-0.682,0.119-1.009,0.229l0.04-0.028
		c-4.58-3.03-5.791-8.793-6.007-10.107c2.375-1.165,5.044-1.816,7.863-1.816C26.581,7.118,28.115,7.322,29.574,7.708z M15.666,9.747
		c-1.523,3.295,4.162,11.909,4.162,11.909l0.231-0.441c-0.235,0.306-0.44,0.633-0.611,0.979l0.009-0.08
		c-5.372,1.208-10.368-1.92-11.462-2.663C9.328,15.381,12.08,11.948,15.666,9.747z M7.558,21.047
		c1.275,3.409,11.352,5.225,11.352,5.225l-0.046-0.238c0.055,0.321,0.132,0.627,0.227,0.924c-2.917,4.778-8.809,6.176-9.903,6.398
		c-1.318-2.491-2.07-5.341-2.07-8.362C7.118,23.648,7.273,22.319,7.558,21.047z M9.97,34.686c3.118,1.642,11.153-4.051,11.691-4.442
		c0.232,0.159,0.483,0.294,0.746,0.413c1.395,5.61-1.959,10.967-2.333,11.532C15.868,40.983,12.291,38.284,9.97,34.686z
		 M21.389,42.51c3.409-0.686,4.934-10.23,5.112-11.472c0.321-0.076,0.627-0.174,0.921-0.306c5.239,3.058,6.637,9.677,6.637,9.677
		l0.643-0.389c-2.792,1.804-6.127,2.859-9.698,2.859C23.768,42.88,22.56,42.754,21.389,42.51z M35.099,39.755
		c2.14-2.81-3.819-10.694-4.645-11.756c0.153-0.278,0.287-0.581,0.403-0.887c5.715-1.632,11.355,1.765,11.575,1.902
		C41.412,33.45,38.739,37.254,35.099,39.755z"
        />
      </g>
    </svg>
  );
}
